import { Component, OnDestroy, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { GlobalEventListenerService } from '../../services/global-event-listener.service';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'topo-color-item-select',
    imports: [CommonModule, FlexLayoutModule],
    templateUrl: './color-item-select.component.html',
    styleUrls: ['./color-item-select.component.scss']
})
export class ColorItemSelectComponent implements OnDestroy {
  @ViewChild('colorSelect') colorSelectControl;
  @Input() selectedUId: string;
  @Input() label: string;
  @Input() placeholderLabel: string;
  @Input() colorCode: string;
  @Input() itemLabel: string;
  @Input() itemColorCode: string;
  @Input() items: any[];
  @Input() isXLarge = false;
  @Input() isLarge = false;
  @Input() isMedium = false;
  @Input() isFilter = false;

  @Output() itemSelected = new EventEmitter<any>();
  clickSubscription: Subscription = null;
  destroy$ = new Subject<void>();
  isActive = false;

  constructor(private eventListenerService: GlobalEventListenerService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getItemColor(colorCode: string): string {
    if (!colorCode) {
      return '#EFEFEF';
    }

    return colorCode;
  }

  showColorItemListClick(elm: any): void {
    if (elm.classList.contains('is-active')) {
      elm.classList.remove('is-active');
      this.isActive = false;

      this.unsubscribeToClicks();
    } else {
      elm.classList.add('is-active');
      this.isActive = true;

      this.subscribeToClicks();
    }
  }

  selectColorItem(item: any): void {
    if (this.colorSelectControl.nativeElement.classList.contains('is-active')) {
      this.colorSelectControl.nativeElement.classList.remove('is-active');
    }

    this.isActive = false;

    this.unsubscribeToClicks();

    this.itemSelected.emit(item);
  }

  subscribeToClicks() {
    if (this.clickSubscription) {
      return;
    }

    this.clickSubscription = this.eventListenerService.clickEvents$.pipe(takeUntil(this.destroy$)).subscribe(target => {
      if (!this.colorSelectControl.nativeElement.contains(target)) {
        this.colorSelectControl.nativeElement.classList.remove('is-active');
        this.unsubscribeToClicks();
      }
    });
  }

  unsubscribeToClicks() {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = null;
    }
  }
}
